const yup = require("yup");

// Schema for createcollegerules
const createProgrammeRules = yup.object({
  department: yup.string().min(2, "Minimum of 2 characters expected").required("Department is required"),
  code: yup.string().min(2, "Minimum of 2 characters expected").required("Code is required"),
  name: yup.string().min(2, "Minimum of 2 characters expected").required("Name is required"),
  status: yup.boolean().required("Status is required"),
  minunit: yup.number().required("Minimum registration unit is required"),
  maxunit: yup.number().required("Maximum registration unit is required"),
});

module.exports = {
  createProgrammeRules,
};
